import React, { forwardRef } from 'react';
import { ellipsis } from 'polished';
import styled from 'styled-components';
import { color, typography } from 'styled-system';
import { Box } from '../grid/Grid';

const StyledHeading = styled(Box)`
  ${color}
  ${typography}
  ${props => props.isTruncated && ellipsis()}
`;

export const Heading = forwardRef(
  ({ m = 0, color = 'blacks.0', fontSize = '36px', fontWeight = 500, lineHeight = 1.5, ...props }, ref) => (
    <StyledHeading
      ref={ref}
      as="h1"
      m={m}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      {...props}
    />
  )
);

Heading.displayName = 'Heading';
